import { render, staticRenderFns } from "./tabProducts.vue?vue&type=template&id=efe27dce&scoped=true"
import script from "./tabProducts.vue?vue&type=script&lang=js"
export * from "./tabProducts.vue?vue&type=script&lang=js"
import style0 from "./tabProducts.vue?vue&type=style&index=0&id=efe27dce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe27dce",
  null
  
)

export default component.exports